<template>
    <div v-if="this.isAdmin != true && this.isSupport != true"> {{
        this.$NOLIMITResource[this.dataUser.language].PermissionPage }}</div>
    <!--begin::Content wrapper-->
    <div v-else class="d-flex flex-column flex-column-fluid">
        <!--begin::Toolbar-->
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6"
            style="padding-top: 0px !important;padding-bottom: 10px !important;">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <h1 class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                        Chi tiêu các doanh nghiệp theo ngày
                    </h1>
                    <!--end::Title-->
                </div>
                <!--end::Page title-->
            </div>
            <!--end::Toolbar container-->
        </div>
        <!--end::Toolbar-->
        <!--begin::Content-->
        <div id="kt_app_content" class="app-content flex-column-fluid">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container">
                <!--begin::Card-->
                <div class="card">
                    <!--begin::Card header-->
                    <div class="card-header border-0 pt-6" style="align-items: center;padding-top: 0px !important;">
                        <!--begin::Card title-->
                        <div class="card-title">
                            <!--begin::Search-->
                            <div class="d-flex align-items-center position-relative my-1">
                                <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                                    <span @click="onEnterSearchFirst" class="path1"
                                        style="cursor:pointer;z-index: 2;"></span>
                                    <span class="path2"></span>
                                </i>
                                <input v-on:keyup.enter="onEnterSearchFirst" v-model="inputValue" type="text"
                                    class="form-control form-control-solid w-250px ps-12"
                                    placeholder="Tìm kiếm theo doanh nghiệp" />
                            </div>
                            <!--end::Search-->
                        </div>
                        <!--begin::Card title-->
                        <!--begin::Card toolbar-->

                        <div class="card-toolbar position-relative" style="margin-left: auto;">
                            <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base"
                                data-select2-id="select2-data-129-1zlu">
                                <!--begin::Filter-->
                                <button @click="toggleMenuFilter" type="button" class="btn btn-light-primary me-3 "
                                    data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                    <i class="ki-duotone ki-filter fs-2">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                    </i>{{ this.$NOLIMITResource[this.dataUser.language].FilterSearch }}</button>
                                <!--begin::Menu 1-->
                                <div class="menu menu-sub menu-sub-dropdown w-300px w-md-325px  show-dropfilter"
                                    :class="{ show: this.onShowMenuFilter == true }" data-kt-menu="true"
                                    id="kt-toolbar-filter" data-select2-id="select2-data-kt-toolbar-filter" style="">
                                    <!--begin::Header-->
                                    <div class="px-7 py-5">
                                        <div class="fs-4 text-gray-900 fw-bold">{{
                                            this.$NOLIMITResource[this.dataUser.language].FilterOptions }}</div>
                                    </div>
                                    <!--end::Header-->
                                    <!--begin::Separator-->
                                    <div class="separator border-gray-200"></div>
                                    <!--end::Separator-->
                                    <form action="" @submit.prevent="onFilterSearch">
                                        <!--begin::Content-->
                                        <div class="px-7 py-5" data-select2-id="select2-data-128-13oj">
                                            <!--begin::Input group-->
                                            <div>
                                                <label class="form-label fs-5 fw-semibold mb-3">{{
                                                    this.$NOLIMITResource[this.dataUser.language].StartDate }}:</label>
                                                <v-date-picker class="inline-block h-full" v-model="dateStart"
                                                    :timezone="timezone2">
                                                    <template v-slot="{ inputValue, togglePopover }">
                                                        <div class="flex items-center">
                                                            <input @click="togglePopover()" :value="inputValue"
                                                                class="form-control form-control-solid flatpickr-input active"
                                                                name="calendar_event_end_date"
                                                                :placeholder="this.$NOLIMITResource[this.dataUser.language].StartDate"
                                                                id="kt_calendar_datepicker_end_date" type="text"
                                                                readonly="readonly" style="margin-bottom:20px">
                                                        </div>
                                                    </template>
                                                </v-date-picker>
                                            </div>
                                            <!--end::Input group-->

                                            <!--begin::Input group-->
                                            <div>
                                                <label class="form-label fs-5 fw-semibold mb-3">{{
                                                    this.$NOLIMITResource[this.dataUser.language].EndDate }}:</label>
                                                <v-date-picker class="inline-block h-full" v-model="dateEnd"
                                                    :timezone="timezone1">
                                                    <template v-slot="{ inputValue, togglePopover }">
                                                        <div class="flex items-center">
                                                            <input @click="togglePopover()" :value="inputValue"
                                                                class="form-control form-control-solid flatpickr-input active"
                                                                name="calendar_event_end_date"
                                                                :placeholder="this.$NOLIMITResource[this.dataUser.language].EndDate"
                                                                type="text" readonly="readonly"
                                                                style="margin-bottom:20px">
                                                        </div>
                                                    </template>
                                                </v-date-picker>
                                            </div>
                                            <!--end::Input group-->


                                            <!--begin::Actions-->
                                            <div class="d-flex justify-content-end">
                                                <button @click="onResetFilter" type="reset"
                                                    class="btn btn-light btn-active-light-primary me-2"
                                                    data-kt-menu-dismiss="true" data-kt-customer-table-filter="reset">{{
                                                        this.$NOLIMITResource[this.dataUser.language].Reset }}</button>
                                                <button type="submit" class="btn btn-primary"
                                                    data-kt-menu-dismiss="true"
                                                    data-kt-customer-table-filter="filter">{{
                                                        this.$NOLIMITResource[this.dataUser.language].Filter }}</button>
                                            </div>
                                            <!--end::Actions-->
                                        </div>
                                        <!--end::Content-->
                                    </form>
                                </div>
                                <!--end::Menu 1-->
                                <!--end::Filter-->

                            </div>
                        </div>
                        <!--end::Card toolbar-->
                    </div>
                    <!--end::Card header-->
                    <!--begin::Card body-->
                    <div class="card-body pt-0" style="margin-top: 20px;">
                        <!--begin::Table-->
                        <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_customers_table">
                            <thead>
                                <tr class="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                    <th class="min-w-125px">Date</th>
                                    <th class="min-w-125px">Doanh nghiệp</th>
                                    <th class="min-w-125px">Số tiền chi tiêu VND</th>
                                    <th class="min-w-125px">Số tiền chi tiêu USD</th>
                                </tr>
                            </thead>
                            <div class="loading-1" v-if="onLoading">
                                <span class="spinner-border text-primary" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </span>
                            </div>
                            <div style="margin-top: 20px;" v-if="!this.onLoading && this.hasData == false">{{
                                this.$NOLIMITResource[this.dataUser.language].UserManagement.Nodata }}</div>
                            <tbody v-if="!this.onLoading && this.hasData == true" class="fw-semibold text-gray-600">
                                <template v-for="(item, index) in users" :key="index">
                                    <tr v-for="(spend, business) in item.spencapByBusiness" :key="business">
                                        <!-- Chỉ hiển thị ngày ở dòng đầu tiên -->
                                        <td>
                                            {{ item.date }}
                                        </td>
                                        <td>{{ business }}</td>
                                        <td>{{ spend.totalSpencapVND }}</td>
                                        <td>{{ spend.totalSpencapUSD }}</td>
                                    </tr>
                                </template>
                                <tr id="total">
                                    <td class="fix-data-footer" colspan="3" style="font-weight: bold"> <img
                                            src="./../../../../../public/frontend/media/logos/logo3.png"
                                            style="width:30px;height:auto" />
                                    </td>
                                    <td></td>
                                    <td></td>

                                </tr>
                            </tbody>
                        </table>
                        <div class="row">
                            <div
                                class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start">
                                <div class="dataTables_length" id="kt_customers_table_length">
                                    <label>
                                        <v-select v-model="this.pageSize" id="styleSelect" :options="numberPerPage"
                                            label="value"></v-select>
                                    </label>
                                </div>
                            </div>
                            <div
                                class="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end">
                                <div class="dataTables_paginate paging_simple_numbers" id="kt_customers_table_paginate">
                                    <ul v-if="this.totalPage >= 4" class="pagination">
                                        <li class="paginate_button page-item previous"
                                            :class="{ disabled: this.pageNumber == 1 }"
                                            id="kt_customers_table_previous">
                                            <a @click="prevPage" aria-controls="kt_customers_table" data-dt-idx="0"
                                                tabindex="0" class="page-link"><i class="previous"></i></a>
                                        </li>
                                        <li v-for="index in 4" :key="index" class="paginate_button page-item"
                                            :class="{ active: pageNumber == this.firstPage + index }">
                                            <a @click="selectPage(this.firstPage + index)"
                                                aria-controls="kt_customers_table" data-dt-idx="1" tabindex="0"
                                                class="page-link">{{ this.firstPage + index }}</a>
                                        </li>
                                        <li class="paginate_button page-item next"
                                            :class="{ disabled: this.pageNumber == this.totalPage }"
                                            id="kt_customers_table_next">
                                            <a @click="nextPage" aria-controls="kt_customers_table" data-dt-idx="5"
                                                tabindex="0" class="page-link"><i class="next"></i></a>
                                        </li>
                                    </ul>
                                    <ul v-if="this.totalPage < 4" class="pagination">
                                        <li class="paginate_button page-item previous"
                                            :class="{ disabled: this.pageNumber == 1 }"
                                            id="kt_customers_table_previous">
                                            <a @click="prevPage" aria-controls="kt_customers_table" data-dt-idx="0"
                                                tabindex="0" class="page-link"><i class="previous"></i></a>
                                        </li>
                                        <li v-for="index in totalPage" :key="index" class="paginate_button page-item"
                                            :class="{ active: pageNumber == this.firstPage + index }">
                                            <a @click="selectPage(this.firstPage + index)"
                                                aria-controls="kt_customers_table" data-dt-idx="1" tabindex="0"
                                                class="page-link">{{ this.firstPage + index }}</a>
                                        </li>
                                        <li class="paginate_button page-item next"
                                            :class="{ disabled: this.pageNumber == this.totalPage }"
                                            id="kt_customers_table_next">
                                            <a @click="nextPage" aria-controls="kt_customers_table" data-dt-idx="5"
                                                tabindex="0" class="page-link"><i class="next"></i></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!--end::Table-->
                    </div>
                    <!--end::Card body-->
                </div>
                <!--end::Card-->
                <!--begin::Modals-->

            </div>
            <!--end::Content container-->
        </div>
        <!--end::Content-->
    </div>
</template>
<style scoped>
.show-dropfilter {
    z-index: 107;
    position: absolute;
    inset: 61px 176px auto auto;
    margin: 0px;
    top: 90px;
    right: 20px;
    text-align: start;
}

.show-dropfilter-2 {
    z-index: 107;
    position: absolute;
    inset: 0px 0px auto auto;
    margin: 0px;
    top: 130px;
    left: 20px;
    text-align: start;
}

.table {
    overflow: scroll;
    height: calc(100vh - 275px);
    display: block;
}

.active__update__combobox {
    z-index: 555 !important;
}

.menu {
    left: -180px;
    top: 53px;
    position: relative;
}

td {
    text-align: start;
}

.menu-sub-dropdown {
    position: absolute;
}

.block {
    display: block;
    background-color: rgba(0, 0, 0, 0.5);
}

.loading-1 {
    height: 500px;
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 50px;
}

.min-w-125px {
    min-width: 400px !important
}

.form-check {
    display: flex;
    /* min-height: 1.5rem; */
    height: 30px;
    padding-left: 2.25rem;
    margin-bottom: 0.125rem;
    align-items: center;
}

.form-check-input {
    margin-right: 10px;
}

.fix-data-footer {
    position: sticky;
    left: 0px;
    background: #fff;
    z-index: 10;
}

.table tr#total {
    position: sticky;
    bottom: 0px;
    left: 0;
    background: #fff;
    z-index: 4;
}

.table tr#total {
    position: sticky;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
import router from '@/router/router.js';
export default {
    name: "DailySpendBusiness",
    data() {
        return {
            timezoneIndex: 20,
            timezoneIndex1: 1,
            timezones: [
                'Pacific/Midway',      // -11
                'Pacific/Niue',        // -11
                'Pacific/Honolulu',    // -10
                'Pacific/Pago_Pago',   // -11
                'America/Anchorage',   // -9
                'America/Los_Angeles', // -8
                'America/Tijuana',     // -8
                'America/Denver',      // -7
                'America/Phoenix',     // -7
                'America/Chicago',      // -6
                'America/Mexico_City', // -6
                'America/Regina',      // -6
                'America/New_York',    // -5
                'America/Caracas',     // -4.5
                'America/Halifax',     // -4
                'America/Argentina/Buenos_Aires', // -3
                'America/Sao_Paulo',   // -3
                'Atlantic/Azores',     // -1
                'Atlantic/Cape_Verde', // -1
                'UTC',                 // 0
                'Europe/London',       // +0
                'Europe/Paris',        // +1
                'Europe/Istanbul',     // +3
                'Europe/Moscow',       // +3
                'Asia/Dubai',          // +4
                'Asia/Yekaterinburg',  // +5
                'Asia/Almaty',         // +6
                'Asia/Colombo',        // +6
                'Asia/Bangkok',        // +7
                'Asia/Ho_Chi_Minh',    // +7
                'Asia/Jakarta',        // +7
                'Asia/Taipei',         // +8
                'Asia/Singapore',      // +8
                'Asia/Kuala_Lumpur',   // +8
                'Asia/Hong_Kong',      // +8
                'Asia/Ulaanbaatar',    // +8
                'Asia/Pyongyang',      // +9
                'Asia/Tokyo',          // +9
                'Australia/Darwin',    // +9.5
                'Australia/Adelaide',  // +10
                'Australia/Sydney',    // +10
                'Pacific/Guam',        // +10
                'Australia/Brisbane',  // +10
                'Asia/Vladivostok',    // +10
                'Pacific/Fiji',        // +12
                'Pacific/Tongatapu',   // +13
                'Pacific/Apia',        // +13
            ],
            dateStart: null,
            dateEnd: null,
            currentUserIdPickBusiness: 0,
            isShowModalPickBusiness: false,
            cardInfoImport: "",
            isShowModalAddBatchCardInfo: false,
            listTagBusiness: [],
            onShowModalAllTagBusiness: false,
            dataUser: { language: "VN" },
            currentIndex: null,
            currentProperty: null,
            sortingAsc: null,
            sortingNumber: null,
            columns: [
                { label: "Ngày", width: 50, property: "Date" },
                { label: "Doanh nghiệp", width: 150, property: "Business" },
                { label: "Chi tiêu VND", width: 250, property: "VND" },
                { label: "Chi tiêu USD", width: 250, property: "USD" },
            ],
            numberPerPage: [10, 50, 200, 500],
            onLoading: true,
            users: [],
            totalRecharge: 0,
            onShowMenu: false,
            currenOnshowId: 0,
            userCurrent: {},
            isShowModal: false,
            currentBalanceUser: 0,
            currentTotalMoneyUser: 0,
            isShowModalUpdateUser: false,
            changeMoney: 0,
            formMode: "",
            pageSize: 10,
            pageNumber: 1,
            totalPage: 0,
            firstPage: 0,
            inputValue: "",
            previousBalance: 0,
            newBalance: 0,
            isAdmin: true,
            isSupport: true,
            hasData: true,
            checkRow: {},
            displayRow: {},
            isShowModalPickRow: false,
            idUser: 0,
            userAll: [],
            isShowModalProvideUserManager: false,
            currentMediateAccountantUser: {},
        };
    },
    watch: {
        dataUser: {
            handler: function () {
                this.columns = [
                    { label: "Ngày", width: 50, property: "Date" },
                    { label: "Doanh nghiệp", width: 150, property: "Business" },
                    { label: "Chi tiêu VND", width: 250, property: "VND" },
                    { label: "Chi tiêu USD", width: 250, property: "USD" },
                ];
            }
        },

        pageSize() {
            this.reDisplay();
        },
        userAll() {
            this.totalRecharge = 0;
            for (let i = 0; i < this.userAll.length; i++) {
                if (this.userAll[i].isAdmin == false) {
                    this.totalRecharge += this.userAll[i].totalMoney
                }
            }


        }

    },
    computed: {
        ...mapGetters("listModule", [
            "onShowMenuFilter",
            "formatCurrency",
            "formatDateTime",
            "convertToEndOfDay",
            "onShowMenuFilterStatus",
            "getStatusAds",
            "language",
        ]),

        formatCurrentBalanceUserDisplay() {
            return this.formatCurrency(this.currentBalanceUser) + " VND";
        },
        formatCurrentTotalMoneyUserDisplay() {
            return this.formatCurrency(this.currentTotalMoneyUser) + " VND";
        },
        formatChangeMoneyDisplay() {
            return this.formatCurrencyValue(this.changeMoney) + " VND";
        },
        timezone2() {
            return this.timezones[this.timezoneIndex];
        },
        timezone1() {
            return this.timezones[this.timezoneIndex1];
        },
        attributes() {
            return [{
                highlight: true,
                dates: this.dateStart,
            }];
        },
    },
    created() {
        this.onShowMenuFilter = false;
        this.$apiService
            .getUserProfile()
            .then((response) => {
                if (response.data.data.language == "VN" || response.data.data.language == "EN") {
                    this.dataUser = response.data.data;
                } else {
                    this.dataUser = response.data.data;
                    this.dataUser.language = "VN";
                }
                this.idUser = response.data.data.userId;
                this.isAdmin = response.data.data.isAdmin;
                this.isSupport = response.data.data.isSupport;
                if (response.data.data.isAdmin != true && response.data.data.isSupport != true) {
                    this.isAdmin = false;
                    this.isSupport = false;
                    router.push({ name: 'ErrorNotFound' });
                }
                this.$apiService
                    .getAllDailySpend("")
                    .then((res) => {
                        setTimeout(() => { this.onLoading = false }, 1000)
                        this.users = res.data.data;
                        if (res.data.data.length == 0) {
                            this.hasData = false;
                        }

                    })
                    .catch((error) => {
                        console.error("Lỗi khi lấy dữ liệu:", error);
                    });


            })
            .catch((error) => {
                console.error("Lỗi khi lấy dữ liệu:", error);
            });

        this.$apiService.getAllUserNoPaging(
        ).then((res) => {
            this.userAll = res.data.data;
        })
    },

    methods: {
        ...mapActions("listModule", ["toggleMenuFilter", "swalSuccess", "swalError", "swalWarning"]),

        onFilterSearch() {
            if (
                (this.dateStart == null ||
                    this.dateEnd == null ||
                    this.dateEnd < this.dateStart) && this.inputValue == ""
            ) {
                this.$apiService.getAllDailySpend(this.keyword).then((res) => {
                    this.users = res.data.data;
                });
            } else if (
                this.dateStart == null ||
                this.dateEnd == null ||
                this.dateEnd < this.dateStart
            ) {
                this.$apiService.getAllDailySpend(this.inputValue).then((res) => {
                    this.users = res.data.data;
                });
            } else {
                const dateEndConvert = this.convertToEndOfDay(this.dateEnd);
                this.$apiService
                    .getAllDailySpendByDate(
                        this.dateStart.toISOString(),
                        dateEndConvert,
                        this.inputValue,
                    )
                    .then((res) => {
                        this.users = res.data.data;
                    });
            }
            this.toggleMenuFilter();
        },
        toggleMenuItem(id) {
            this.onShowMenu = !this.onShowMenu;
            this.currenOnshowId = id;
        },
        openModalAllCardInfo() {
            this.$apiService.getAllTagBusiness().then((res) => {
                this.listTagBusiness = res.data.data;
            })
            this.onShowModalAllTagBusiness = true;
        },
        closeModalAllCardInfo() {
            this.onShowModalAllTagBusiness = false;
        },
        openModalAddBatchCardInfo() {
            this.isShowModalAddBatchCardInfo = true;
        },
        closeModalAddBatchCardInfo() {
            this.isShowModalAddBatchCardInfo = false;
        },
        convertStringToArray() {
            const formData = new FormData();
            formData.append('business', this.cardInfoImport);
            this.$apiService.importManyBusiness(formData)
                .then(() => {
                    this.reDisplay()
                    this.swalSuccess("Thêm nhãn dán thành công!")
                    this.closeModalAddBatchCardInfo();
                    this.closeModalAllCardInfo();
                }).catch((error) => {
                    this.swalError({ message: error.response.data.message, language: "VN" })
                })
        },
        selectPage(index) {
            this.pageNumber = index;
            if (this.totalPage >= 4) {
                if (index == this.totalPage) {
                    this.firstPage = index - 4;
                } else if (index >= 3) {
                    this.firstPage = index - 3;
                } else {
                    this.firstPage = 0;
                }
            }
            this.onEnterSearch();
        },
        reDisplay() {
            this.hasData = true;
            this.$apiService
                .getAllUserPanigation(this.pageNumber, this.pageSize)
                .then((res) => {
                    this.onLoading = true
                    setTimeout(() => { this.onLoading = false }, 1000)
                    this.users = res.data.data;
                    if (res.data.data.length == 0) {
                        this.hasData = false;
                    }
                    this.totalPage = res.data.pageData.pageCount;
                })
                .catch((error) => {
                    console.error("Lỗi khi lấy dữ liệu:", error);
                });
            this.$apiService.getAllUserNoPaging(
            ).then((res) => {
                this.userAll = res.data.data;
            })
        },
        /**
         * Chọn next trang tiếp theo trong mục phân trang
         * Author: ndanh (20/09/2023)
         */
        nextPage() {
            if (this.pageNumber != this.totalPage) {
                this.pageNumber += 1;
                if (this.totalPage >= 4) {
                    if (this.pageNumber == this.totalPage) {
                        this.firstPage = this.pageNumber - 4;
                    } else if (this.pageNumber >= 3) {
                        this.firstPage = this.pageNumber - 3;
                    } else {
                        this.firstPage = 0;
                    }
                }
            }
            this.onEnterSearch();
        },
        /**
         * Chọn prev trang trước đó trong mục phân trang
         * Author: ndanh (20/09/2023)
         */
        prevPage() {
            if (this.pageNumber != 1) {
                this.pageNumber -= 1;
                if (this.totalPage >= 4) {
                    if (this.pageNumber == this.totalPage) {
                        this.firstPage = this.pageNumber - 4;
                    } else if (this.pageNumber >= 3) {
                        this.firstPage = this.pageNumber - 3;
                    } else {
                        this.firstPage = 0;
                    }
                }
            }
            this.onEnterSearch();
        },
        onEnterSearch() {
            this.hasData = true;
            if (this.inputValue == "") {
                this.reDisplay();
            } else {
                this.$apiService
                    .getAllDailySpend(
                        this.inputValue
                    )
                    .then((res) => {
                        this.onLoading = true
                        setTimeout(() => { this.onLoading = false }, 1000)
                        this.users = res.data.data;
                        if (res.data.data.length == 0) {
                            this.hasData = false;
                        }

                    })
                    .catch((error) => {
                        console.error("Lỗi khi lấy dữ liệu:", error);
                    });
            }
        },
        onEnterSearchFirst() {
            this.hasData = true;
            if (this.inputValue == "") {
                this.reDisplay();
            } else {
                this.$apiService
                    .getAllDailySpend(
                        this.inputValue
                    )
                    .then((res) => {
                        this.onLoading = true
                        setTimeout(() => { this.onLoading = false }, 1000)
                        this.users = res.data.data;
                        if (res.data.data.length == 0) {
                            this.hasData = false;
                        }

                    })
                    .catch((error) => {
                        console.error("Lỗi khi lấy dữ liệu:", error);
                    });
            }
        },

        choosePageSize(event) {
            this.pageSize = event.target.value;
            this.reDisplay();
        },

        startResize(event, index) {
            if (event.offsetX > event.target.offsetWidth - 10) {
                this.isResizing = true;
                this.initialX = event.clientX;
                this.initialWidth = this.columns[index].width;
                this.resizingCol = index;

                document.addEventListener('mousemove', this.handleMouseMove);
                document.addEventListener('mouseup', this.handleMouseUp);
            }
        },
        handleMouseMove(event) {
            if (this.isResizing && this.resizingCol !== null) {
                const delta = event.clientX - this.initialX;
                const newWidth = Math.max(50, this.initialWidth + delta);
                this.columns[this.resizingCol] = { ...this.columns[this.resizingCol], width: newWidth };
            }
        },
        handleMouseUp() {
            this.isResizing = false;
            this.initialX = 0;
            this.initialWidth = 0;
            this.resizingCol = null;

            document.removeEventListener('mousemove', this.handleMouseMove);
            document.removeEventListener('mouseup', this.handleMouseUp);
        },
        shouldDisplay(index) {
            switch (index) {
                case 1:
                    return this.displayRow.username;
                case 2:
                    return this.displayRow.roleUser;
                case 3:
                    return this.displayRow.fullnameUser;
                case 4:
                    return this.displayRow.email;
                case 5:
                    return this.displayRow.statusBanUser;
                case 6:
                    return this.displayRow.balanceUser;
                case 7:
                    return this.displayRow.totalMoneyUser;
                case 8:
                    return this.displayRow.moneyOutUser;
                case 9:
                    return this.displayRow.moneyInUser;
                case 10:
                    return this.displayRow.topupFeeUser;
                // Thêm các trường hợp khác tương ứng
                default:
                    return true; // Hiển thị mặc định nếu không có điều kiện nào khớp
            }
        },
        formatCurrencyValue(value) {
            // Chuyển đổi số thành chuỗi
            let stringValue = value.toString();

            // Chia chuỗi thành mảng các nhóm mỗi 3 chữ số
            let parts = stringValue.split('.');
            let mainPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            // Nếu có phần thập phân, thêm vào chuỗi
            let result = parts.length > 1 ? mainPart + ',' + parts[1] : mainPart;

            return result;
        },

        openModalPickBusiness(id) {
            this.$apiService.getAllTagBusiness().then((res) => {
                this.listTagBusiness = res.data.data;
            })
            this.currentUserIdPickBusiness = id;
            this.isShowModalPickBusiness = true;
        },
        closeModalPickBusiness() {
            this.isShowModalPickBusiness = false;
        },
        addTagBusinessToUser(userId, businessId) {
            this.$apiService.addTagBusinessToUser(userId, businessId).then(() => {
                this.swalSuccess("Thêm nhãn doanh nghiệp thành công!")
                this.onShowMenu = !this.onShowMenu;
                this.isShowModalPickBusiness = false;
                this.reDisplay()
            })
        },
        deleteBusiness(userId) {
            this.$apiService.deleteTagBusinessUser(userId).then(() => {
                this.swalSuccess("Xoá nhãn doanh nghiệp thành công!")
                this.onShowMenu = !this.onShowMenu;
                this.reDisplay()
            })
        }
    },
};
</script>